
import toastr from 'toastr';

angular.module("persons_treatments")

    .controller("PersonsTreatmentsEditCtrl", ['LoginService', '$scope', '$rootScope', '$state', '$stateParams', 'Restangular', 'gridService', '$filter', '$translate', 'modalService', '$uibModal',
        function (LoginService, $scope, $rootScope, $state, $stateParams, Restangular, gridService, $filter, $translate, modalService, $uibModal) {

            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("STAFF_POSITION_WRITE");

            $rootScope.title = $filter('translate')('persons_treatments.title');

            $scope.person_treatment = {
            };
            if (angular.isUndefined($stateParams.id) || $stateParams.id == "") {

                $rootScope.breadcrumb = [
                    { title: $filter('translate')('persons_treatments.title'), url: "persons_treatments.list" },
                    { title: $filter('translate')('persons_treatments.button_add') },
                ];

            } else {

                $rootScope.breadcrumb = [
                    { title: $filter('translate')('persons_treatments.title'), url: "persons_treatments.list" },
                    { title: $filter('translate')('persons_treatments.button_edit') },
                ];

                Restangular.one('PersonsTreatments', $stateParams.id).get().then(function (result) {

                    $scope.person_treatment = result;

                });
            }

            $scope.savePersonsTreatment = function () {
                if (angular.isDefined($scope.id)) {
                    $scope.person_treatment.put().then(function (result) {
                        if (angular.isDefined(result.id)) {
                            toastr.success($filter('translate')('persons_treatments.save_success'));
                            $state.go("persons_treatments.list");
                        }
                    });
                } else {
                    Restangular.all('PersonsTreatments').post($scope.person_treatment).then(function (result) {
                        if (angular.isDefined(result.id)) {
                            toastr.success($filter('translate')('persons_treatments.edit_success'));
                            $state.go("persons_treatments.list");
                        }
                    });
                }
            }

            $scope.checkDelete = function () {
                modalService.confirm({
                    title: $filter('translate')('persons_treatments.button_delete'),
                    message: $filter('translate')('persons_treatments.delete_message') + " " + $scope.person_treatment.name + "?",
                    onAccept: function () {
                        $scope.person_treatment.remove().then(function () {
                            toastr.success($filter('translate')('persons_treatments.deleted_success'));
                            $state.go("persons_treatments.list");
                        });
                    }
                });
            };

        }])

;

